export class OidcClaimTypes {
    //IAL – Identity Assurance Level // scope - id, quality
    public static IAL: string = "http://schema.id.rs/claims/ial";

    //AAL – Authentication Assurance Level  //scope - id, quality
    public static AAL: string = "http://schema.id.rs/claims/aal";

    //Jedinstveni matični broj građana (JMBG, engl. UMCN – Unique Master Citizen Number)  //scope - id
    public static JMBG: string = "http://schema.id.rs/claims/umcn";

    //Ime  //scope - id, name
    public static IME: string = "http://schema.id.rs/claims/givenname";

    //Prezime //scope - id, name
    public static PREZIME: string = "http://schema.id.rs/claims/familyname";

    //Adresa elektronske pošte //scope - mail
    public static EMAIL: string = "http://schema.id.rs/claims/mail";

    //Ulica i broj //scope - residence
    public static ULICA_BROJ: string = "http://schema.id.rs/claims/streetaddress";

    //Poštanski broj  //scope - residence
    public static POSTANSKI_BROJ: string = "http://schema.id.rs/claims/postalcode";

    //Grad  //scope -residence
    public static GRAD: string = "http://schema.id.rs/claims/city";

    //Država  //scope - residence
    public static DRZAVA: string = "http://schema.id.rs/claims/country";

    //Kategorija korisnika  // scope - id
    public static KATEGORIJA_KORISNIKA: string = "http://schema.id.rs/claims/usercategory";

    //Tip jedinstvenog broja  // scope - id
    public static TIP_JEDINSTVENOG_BROJA: string = "http://schema.id.rs/claims/umcntype";
}